<template>
    <div class="position-relative speech-carousel">

        <template v-if="data.length">
            <VueSlickCarousel v-bind="settings" @afterChange="change">
                <SpeechCard
                    v-for="item in data"
                    :key="item.id"
                    :text="item.item[textKey]"
                    :show-score="showScore(item)"
                    :score="parseInt(item.item[scoreKey])"
                    :show-user="showUser(item)"
                    :user="user(item)"
                />
            </VueSlickCarousel>
        </template>

        <MoonSpinner
            v-else
            :loading="loading"
            container-size="160px"/>
    </div>
</template>

<script>
    import axios from 'axios';
    import VueSlickCarousel from 'vue-slick-carousel';
    import SpeechCard from '@/components/carousels/cards/Speech';
    import 'vue-slick-carousel/dist/vue-slick-carousel.css';
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
    import MoonSpinner from "@/components/spinners/MoonSpinner";

    export default {
        name: 'SpeechCarousel',
        components: {VueSlickCarousel, SpeechCard, MoonSpinner},

        props: {
            endpoint: {
                type: String,
                required: true
            },

            query: {
                type: String,
                required: false
            },

            textKey: {
                type: String,
                required: true
            },

            scoreKey: {
                type: String,
                required: false,
                default: 'score'
            },
        },

        data() {
          return {
              data: [],
              items: '',
              index: 0,
              loading: true,
              settings: {
                  "autoplay": true,
                  "focusOnSelect": true,
                  "infinite": true,
                  "slidesToShow": 3,
                  "speed": 500,
                  'autoplaySpeed': 4000,
                  "arrows": true,
                  "responsive": [
                      {
                          "breakpoint": 1020,
                          "settings": {
                              "slidesToShow": 2
                          }
                      },
                      {
                          "breakpoint": 720,
                          "settings": {
                              "slidesToShow": 1
                          }
                      },
                  ],
              }
          }
        },

        computed: {
            compiledEndpoint() {
                return '/api' + this.endpoint + (this.query ? this.query : '');
            },
            slidesCount() {
                return this.data.length > 3 ? 3 : this.data.length;
            }
        },

        watch: {
            slidesCount: {
                immediate: true,
                handler(count) {
                    this.settings.slidesToShow = count;
                }
            }
        },

        mounted() {
            this.getItems();
        },

        methods: {

            getItems() {
                const $this = this;
                return new Promise((resolve, reject) => {
                    axios
                        .get(this.compiledEndpoint)
                        .then(({ data }) => {
                            $this.data = data;
                            this.loading = false;
                            return resolve();
                        })
                        .catch((error) => {
                            this.loading = false;
                            return reject();
                        });
                });
            },

            showScore(item) {
                return !!item.item.score;
            },

            showUser(item) {
                return !!item.item.show_user && item.item.show_user !== '0';
            },

            user(item) {
                let user = {
                    imagePath: item.acf_fields.user_image ? item.acf_fields.user_image.url : '',
                    firstLine: item.item.user_name,
                    secondLine: item.item.user_second_line,
                    thirdLine:  item.acf_fields.user_date ? item.acf_fields.user_date : '',
                }

                return item.item.show_user ? user : {};
            },

            change(index) {
                this.index = index;
            }
        }
    }
</script>
